import {
  COGNITO_TOKEN_REQUEST_SOURCE,
  getCognitoTokenForRequest,
} from "@src/appV2/api/getCognitoTokenForRequest";

export async function getAuthHeader(): Promise<{ Authorization: string | null }> {
  const cognitoToken = await getCognitoTokenForRequest({
    source: COGNITO_TOKEN_REQUEST_SOURCE.superagentHelper,
  });
  if (typeof cognitoToken === "string" && cognitoToken.length > 0) {
    return { Authorization: `Bearer ${cognitoToken}` };
  }

  /**
   * ***** WARNING ****
   *  `superagent` requires Authorization to either be a string, or null
   * DO NOT SET `Authorization` to `undefined` because you will break sign in flow
   * See https://app.datadoghq.com/incidents/102
   */
  return { Authorization: null };
}
